import React from 'react'

interface LabelDataProps {
    labelName: string;
    labelValue: string;
    addValue?: string;
}

export default function LabelData({ labelName, labelValue, addValue } : LabelDataProps ) {
    return (
        <div className='flex flex-col'>
            <p className='text-sm'>{labelName}:</p>
            <p className='text-[15px] font-medium break-words'>{labelValue}</p>
            {addValue?.length !== 0 && (
                <p className='text-[15px] font-medium break-words'>{addValue}</p>
            )}
            
        </div>
    )
}
